"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTL007_Detail = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const common_1 = require("../../../common");
const sms_1 = require("../../../server/sms");
const DeletePopUpLayout_1 = require("../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../base/popup");
const constant_1 = require("./constant");
const ChoiceMemberTable_1 = require("./DSTL007_Send_Child/ChoiceMemberTable");
const react_redux_1 = require("react-redux");
const action_1 = require("../../menu/action");
const SendSMSRegist_1 = require("./DSTL007_Send_Child/SendSMSRegist");
const commonStyles = (0, styled_components_1.css) `
	background: #fcfcfc;
	border-radius: 0px 0px 12px 12px;
	width: 100%;
	display: flex;

	.fext-field {
		border: none;
	}

	.open-contents {
		width: 100%;
		display: flex;
	}

	.notice-content {
		width: 100%;
	}

	.receiver-wrap {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;

		.button {
			background: var(--bg-bgw1, #f3f4f8);
			border-radius: 100px;
			padding: 8px 10px 8px 10px;
			display: flex;
			flex-direction: row;
			gap: 4px;
			row-gap: 0px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--font-dgrey, #4d4d4d);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 10px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
			}
		}
	}

	.setting_box {
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 100%;
		position: relative;
		text-overflow: ellipsis;
		white-space: nowrap;
		align-items: flex-start;

		.receiver-count {
			color: var(--color-grey, #666666);
			text-align: left;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
	}

	.teacher-info {
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		padding: 0px 0px 8px 0px;
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-end;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		letter-spacing: var(--b4-letter-spacing, -0.02em);
		font-weight: var(--b4-font-weight, 400);
		color: var(--color-grey, #666666);

		.name {
			display: flex;
			flex-direction: row;
			gap: 12px;
		}
	}

	.btn-container {
		padding-top: 0px;
		display: flex;
		flex-direction: row;
		width: 100%;
		margin: 0px;
	}

	.underline {
		text-decoration: underline;
	}

	.green {
		color: var(--tur-d, #479da6);
	}

	.pink {
		color: var(--color-accent, #e7424c);
	}

	.open-contents {
		background: var(--color-white, #ffffff);
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		box-shadow: var(--shadow-bg-box-shadow, 0px 2px 6px 0px rgba(224, 226, 235, 0.4));
		overflow: auto;

		color: var(--natural-color-n-0, #2f2f2f);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
	}

	.notice-content {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		color: var(--natural-color-n-0, #2f2f2f);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;

		.img_wrap {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			.img {
				border-radius: 4px;
				flex-shrink: 0;
				width: 100px;
				height: 100px;
				position: relative;
				object-fit: cover;
				background: #000;
			}
		}
	}

	svg {
		min-width: 16px;
	}
`;
const mobileStyles = (0, styled_components_1.css) `
	padding: 10px;

	.setting_box {
		flex-wrap: prev-wrap !important;

		p {
			font-size: 12px;
		}
	}

	.md_round {
		padding: 2px 8px;
		height: 30px;
	}

	.receiver-wrap {
		gap: 4px;
	}

	.receiver {
		p {
			padding-bottom: 3px;
			max-width: 60px;
			min-width: fit-content;
			font-size: var(--b-l-medium-font-size, 12px);
			line-height: var(--b-l-medium-line-height, 22px);
		}
	}

	.receiver-count {
		font-size: 12px;
		line-height: 150%;
		letter-spacing: -0.02em;
	}

	.open-contents {
		padding: 16px 20px;
	}

	.teacher-info {
		border-width: 0px 0px 0.5px 0px;
		.active-bar {
			.button p {
				min-width: fit-content;
				font-size: 12px;
			}
		}
	}

	.notice-content {
		gap: 12px;
		.img_wrap {
			gap: 8px;
			display: flex;
			flex-wrap: wrap;
			width: 100%;
		}
		.img_pair {
			display: flex;
			flex-direction: column;
			gap: 8px;
		}
	}

	.xmd {
		padding: 8px 10px !important;
		height: 38px;
	}

	.sms-preview-content {
		width: 100%;
    	word-wrap: break-word;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	padding: 20px;

	.receiver {
		p {
			max-width: 60px;
			min-width: fit-content;
			font-size: 10px;
			line-height: 150%;
		}
	}

	.receiver-wrap {
		gap: 8px;
	}

	.receiver-count {
		font-size: 12px;
		line-height: 150%;
		letter-spacing: -0.02em;
	}

	.receiver-wrap {
		π button {
			padding: 8px 10px;
		}
	}

	.open-contents {
		padding: 20px;
		overflow: hidden;
	}

	.notice-content {
		overflow: auto;
		.img_wrap {
			gap: 12px;
		}
	}

	.teacher-info {
		border-width: 0px 0px 1px 0px;
		.active-bar {
			.button p {
				min-width: fit-content;
			}
		}
	}

	.setting_box {
		padding: 20px 10px 10px 10px;
	}

	.quill_wrap {
		font-size: 16px;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	padding: 30px;

	.receiver {
		p {
			max-width: 60px;
			min-width: fit-content;
			font-size: 10px;
			line-height: 150%;
		}
	}

	.quill_wrap {
		font-size: 16px;
	}

	.receiver-wrap {
		gap: 12px;
	}

	.receiver-count {
		font-size: var(--b3-font-size, 16px);
		line-height: var(--b3-line-height, 32px);
		letter-spacing: var(--b3-letter-spacing, -0.02em);
	}

	.open-contents {
		padding: 24px 28px;
		overflow: hidden;
	}

	.notice-content {
		overflow: auto;
	}

	.teacher-info {
		border-width: 0px 0px 1px 0px;
		.active-bar {
			.button p {
				min-width: fit-content;
			}
		}
	}

	.setting_box {
		padding: 20px 10px 10px 10px;
	}
`;
const DSTL007DetailStyled = styled_components_1.default.div `
	${commonStyles}
	${props => (props.$isMobile ? mobileStyles : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const DSTL007_Detail = ({ selectedId, setSelectedId, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [item, setItem] = react_1.default.useState(undefined);
    const [receiversList, setReceiverList] = react_1.default.useState([]);
    const [isNormal, setIsNormal] = react_1.default.useState(false);
    const previewRef = react_1.default.useRef(null);
    const deletePostMutation = (0, react_query_1.useMutation)(sms_1.postDeleteSendSMS);
    const { data, refetch } = (0, sms_1.useSendSMSList)({
        id: selectedId,
    });
    const { data: receiversData, refetch: receiversRefetch } = (0, sms_1.useSMSReceiversList)({
        id: selectedId,
    });
    const refetchList = (0, throttle_1.default)(() => refetch(), 1000, { leading: true, trailing: false });
    const refetchReceiversList = (0, throttle_1.default)(() => receiversRefetch(), 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        if (selectedId) {
            refetchList();
            refetchReceiversList();
        }
        else {
            setItem(undefined);
        }
    }, [selectedId]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { items } = data;
            if (items && items.length >= 1) {
                const item = items[0];
                setItem(item);
                return;
            }
        }
        setItem(undefined);
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (receiversData) {
            const { receivers, message_type } = receiversData;
            if (message_type === 'normal') {
                setIsNormal(true);
            }
            else {
                setIsNormal(false);
            }
            if (receivers && receivers.length >= 1) {
                const simpleItems = receivers.map(item => {
                    const baseData = [item[0], item[1]];
                    const extraData = item.slice(2, 6);
                    const data = message_type === 'normal' ? baseData : [...baseData, ...extraData];
                    return {
                        id: item[1],
                        data,
                    };
                });
                setReceiverList(simpleItems);
            }
        }
    }, [receiversData]);
    (0, react_1.useEffect)(() => {
        if (!previewRef.current)
            return;
        const previewTitle = item?.title.length > 0 ? `<span style="font-weight: bold;">${item.title}</span><br>` : '';
        const preview = previewTitle + item?.content;
        if (!preview) {
            previewRef.current.innerHTML = "<span style='color: gray;'>내용 없음</span>";
            return;
        }
        const highlightedText = preview.replace(/#\{(.*?)\}/g, (match, word) => {
            return SendSMSRegist_1.substitutes.includes(word)
                ? `<span style="color: #8268d9;">${match}</span>`
                : match;
        });
        previewRef.current.innerHTML = highlightedText;
    }, [item, SendSMSRegist_1.substitutes]);
    //게시글 삭제
    const handleDelete = () => {
        const onDelete = async () => {
            const id = item.id;
            try {
                APP.eventManager.publish('SHOW_LOADING', true);
                await deletePostMutation.mutateAsync(id);
                APP.eventManager.publish('UPDATE_SEND_SMS');
                if (selectedId === id)
                    setSelectedId(undefined);
            }
            catch (error) {
                console.error('Failed to post deletePost:', error);
                alert(error);
            }
            finally {
                APP.eventManager.publish('SHOW_LOADING', false);
            }
        };
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: t('assignment.delteInto', { count: 1 }),
                onDelete,
            },
            width: 639,
            title: t(`sendSMS.messageDelete`),
            isFit: true,
        });
    };
    //게시글 수정
    const handleEdit = () => {
        dispatch((0, action_1.updateMenu)(undefined, { menu: 'sendSMS', detail: 'regist' }, selectedId));
    };
    //수신자 더보기 클릭 시 팝업창 이동
    const handleMoreReceiver = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            className: 'send-popup',
            component: ChoiceMemberTable_1.ChoiceMemberList,
            componentProps: {
                memberList: receiversList,
                isNotChecked: true,
                isPopup: true,
                isNormal: isNormal,
            },
            width: 580,
            title: '수신자 목록',
            isFit: true,
        });
    };
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    if (!item)
        return null;
    return (react_1.default.createElement(DSTL007DetailStyled, { className: "open-contents", "$isMobile": isMobile, "$isTablet": isTablet },
        react_1.default.createElement("div", { className: "notice-content" },
            react_1.default.createElement("div", { className: "sms-preview-content", ref: previewRef }),
            react_1.default.createElement("div", { className: "fext-field setting_box" },
                react_1.default.createElement(common_1.Button, { className: "button btn_line_light_tur md_round receiver", text: `수신자 (
							${receiversList.length === 0 ? '00' : receiversList.length.toString().padStart(2, '0')}
							) 명`, option: {
                        buttonAfterIcon: {
                            show: true,
                            className: 'arrow-right',
                            name: 'twoarrow',
                            size: 16,
                        },
                    }, onClick: handleMoreReceiver })),
            react_1.default.createElement("div", { className: "btn-container" },
                item.status === constant_1.SMS_STATUS.CREATED && (react_1.default.createElement(common_1.Button, { className: "btn_line_tur xmd", text: 'common.modify', onClick: handleEdit, styles: { buttonWrap: { flex: 1 } } })),
                react_1.default.createElement(common_1.Button, { className: "btn_line_pink xmd", text: 'common.delete', onClick: handleDelete, styles: { buttonWrap: { flex: 1 } } })))));
};
exports.DSTL007_Detail = DSTL007_Detail;
